import { g as o } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as n, openBlock as r, normalizeClass as d, createElementVNode as a } from "vue";
import { _ as l } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconAsana",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = o();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["fill"], m = ["id"], f = /* @__PURE__ */ a("stop", { "stop-color": "#FFB900" }, null, -1), p = /* @__PURE__ */ a("stop", {
  offset: ".6",
  "stop-color": "#F95D8F"
}, null, -1), h = /* @__PURE__ */ a("stop", {
  offset: ".999",
  "stop-color": "#F95353"
}, null, -1), g = [
  f,
  p,
  h
];
function I(e, S, s, b, q, t) {
  return r(), n("svg", {
    "aria-label": s.ariaLabel,
    class: d([t.iconSizeClass, "d-icon d-icon--asana"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Asana",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("path", {
      d: "M17.65 12.787a4.35 4.35 0 1 0 0 8.699 4.35 4.35 0 0 0 0-8.7Zm-11.3 0a4.35 4.35 0 1 0 0 8.7 4.35 4.35 0 0 0 0-8.7Zm10-5.437a4.35 4.35 0 1 1-8.7 0 4.35 4.35 0 0 1 8.7 0Z",
      fill: `url(#${e.uniqueID}a)`
    }, null, 8, u),
    a("defs", null, [
      a("radialGradient", {
        id: `${e.uniqueID}a`,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(13.2526 0 0 12.2495 12 13.103)"
      }, g, 8, m)
    ])
  ], 10, _);
}
const x = /* @__PURE__ */ l(c, [["render", I]]);
export {
  x as default
};
//# sourceMappingURL=asana.js.map
